import React, { useState, useEffect } from 'react';

import api from '../../services/api';
import NewPlanCard from '../NewPlanCard';
import { findPlanBySlug } from '../../utils/planSlug';

// import PlanCard from '../PlanCard';

import { Container, Spinner } from './styles';

const ListPlans = ({ preSelectedPlanSlug = '', onSelectPlan = () => {} }) => {
  const [selectedPlan, setSelectedPlan] = useState('');
  const [plans, setPlans] = useState([{ id: '', name: '', price: 0 }]);
  const [showLoad, setShowLoad] = useState(false);

  const loadPlans = async () => {
    setShowLoad(true);

    try {
      const response = await api.get('/plan-types?isVisible=true');
      setPlans(response.data);

      const matchedPlan = findPlanBySlug(response.data, preSelectedPlanSlug);

      if (matchedPlan) {
        localStorage.setItem('YogaCO@ChoosedPlan', matchedPlan.id);
        setSelectedPlan(matchedPlan.id);
      }
    } catch (error) {}

    setShowLoad(false);
  };

  function renderPlans() {
    if (showLoad) {
      return <Spinner />;
    }

    /* const listPlansComponent = plans.map((plan) => (
      <PlanCard
        data={plan}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />
    )); */

    const listPlansComponent = plans.map((plan) => (
      <NewPlanCard
        plan={plan}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
        onSelectPlan={onSelectPlan}
      />
    ));

    return listPlansComponent;
  }

  useEffect(() => {
    loadPlans();
  }, []);

  return <Container>{renderPlans()}</Container>;
};

export default ListPlans;
